import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import GradientHero from "../components/gradientHero";
import Layout from "../components/layout";

const About = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "about-us", idType: URI) {
          title
          aboutUsPage {
            heroHeader
            heroImage {
              altText
              sourceUrl
            }
            mainContent
            mainLink {
              title
              target
              url
            }
            optionsItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
            questionsHeader
            summaryContent
            summaryLink {
              target
              title
              url
            }
            questionsItems {
              content
              heading
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.aboutUsPage || {};

  return (
    <Layout pageContext={pageContext}>
      <GradientHero image={data?.heroImage?.sourceUrl}>
        <h5>{data?.heroHeader}</h5>
      </GradientHero>

      <div className="bg-black">
        <div className="max-w-7xl text-center mx-5 md:mx-20 lg:mx-auto pt-3 pb-20">
          <p className="mb-10 text-xl text-white mt-10">
            {data?.summaryContent}
          </p>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-5 py-2"
            href={data?.summaryLink?.url}
            target={data?.summaryLink?.target}
          >
            {data?.summaryLink?.title}
          </a>
        </div>
      </div>

      <div>
        <div className="max-w-6xl flex flex-wrap lg:flex-nowrap mx-5 md:mx-20 lg:mx-auto gap-x-14 gap-y-14 mt-20">
          {data?.questionsItems.map((v, i) => (
            <div key={i} className="w-full lg:w-1/3 px-3">
              <h3 className="text-black text-3xl">{v.heading}</h3>
              <p className="text-xl font-light mt-3">{v.content}</p>
            </div>
          ))}
        </div>
        <h5 className="text-black text-center my-20 text-3xl">
          {data?.questionsHeader}
        </h5>
      </div>

      <div className="bg-customGrey mt-20">
        <div className="max-w-5xl mx-auto py-20 p-container">
          <p
            className="text-xl leading-8 mb-7"
            dangerouslySetInnerHTML={{ __html: data?.mainContent }}
          ></p>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-5 py-2"
            href={data?.mainLink?.url}
            target={data?.mainLink?.target}
          >
            {data?.mainLink?.title}
          </a>
        </div>
      </div>

      <div className="bg-black py-20">
        <div className="flex flex-wrap mx-auto w-full md:w-4/5 lg:w-3/4 xl:w-11/12 2xl:w-4/5 overflow-hidden text-white text-center max-w-7xl">
          {data?.optionsItems.map((v, i) => (
            <div
              key={i}
              className="my-4 px-4 w-1/2 overflow-hidden w-full md:w-1/2 lg:w-1/2 xl:w-1/4"
            >
              <div className="mx-auto max-w-76 h-32 flex items-center">
                <img className="w-full" src={v?.image?.sourceUrl} />
              </div>
              <h5 className="text-center text-3xl">{v?.heading}</h5>
              <p className="text-xl leading-8 mt-2 font-light">{v?.content}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default About;
